module.exports = __webpack_public_path__ + "assets/img/未标题-2.63e009b9.png";